import { FormBase } from 'core/components';

export default class CloseOutExitForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'warehouse',
					label: 'CLOSEOUTEXITVIEW.WAREHOUSE',
					rules: 'required',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/CloseOutExitForm.js